import React from 'react';
import './Footer.css'

const Footer = () => {
  const menuItems = [
    {
      title: 'TERMS OF USE',
      link: 'https://zinnov.com/terms-and-conditions/'
    },
    {
      title: 'PRIVACY',
      link: 'https://zinnov.com/privacy/'
    },
    {
      title: 'COOKIE POLICY',
      link: 'https://zinnov.com/cookie-policy/'
    },
    {
      title: 'CONTACT US',
      link: 'https://zinnov.com/contact-us/'
    },
    {
      title: 'SITEMAP',
      link: 'https://zinnov.com/sitemap/'
    }
  ];

  const submenuItems = [
    {
      title: 'INSIGHTS',
      link: 'https://zinnov.com/insights/'
    },
    {
      title: 'CAREERS',
      link: 'https://zinnov.com/careers/'
    },
    {
      title: 'ABOUT US',
      link: 'https://zinnov.com/about-us/our-purpose/'
    },
    {
      title: 'PODCASTS',
      link: 'https://zinnov.com/podcasts/'
    },
    {
      title: 'CASE STUDIES',
      link: 'https://zinnov.com/case-studies/'
    }
  ];

  const subsubmenuItems = [
    {
      title: 'EVENTS',
      link: 'https://zinnov.com/event/upcoming-events/'
    },
    {
      title: 'ZINNOV CONFLUENCE',
      link: 'https://confluence.zinnov.com/india'
    },
    {
      title: 'ZINNOV AWARDS',
      link: 'https://awards.zinnov.com/'
    },
    {
      title: 'ZINNOV ZONES',
      link: 'https://zinnovzones.com/'
    }
  ];

  return (
    <footer id="main-footer" className="">
      <div className="footer-menu-class">
        <ul id="menu-footer" className="menu">
            <li className='menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children'>
                <ul className='sub-menu'><MenuItemList items={menuItems} /></ul>
            </li>
            <li className='menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children'>
                  <ul className='sub-menu'><MenuItemList items={submenuItems} /></ul>
            </li>
            <li className='menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children'>
                  <ul className='sub-menu'><MenuItemList items={subsubmenuItems} /></ul>
            </li>
        </ul>
        <div className="footer-brand">
              <a href="https://zinnov.com/"><img className="menu-logo" height="29" src="https://zinnov.com/wp-content/themes/zinnov/assets/logo.png" alt="Zinnov" /></a>
              <div className="footer-copy-brand">© 2001-{new Date().getFullYear()} ZINNOV</div>
        </div>
      </div>
   
    </footer>
  );
};

const MenuItemList = ({ items }) => (
  items.map((item, index) => (
    <li className='menu-item menu-item-type-post_type menu-item-object-page' key={index}>
      <a href={item.link}>{item.title}</a>
    </li>
  ))
);

export default Footer;

